<script lang="ts" context="module">
	export const DEALS_AISLE_ID = 187;
</script>
<script lang="ts">
	import type { ProductData, StoreLanding } from "$lib/def/landing";
	import { fetch$ } from "$lib/serv/core/cache";
	import { SPKEYS, getDB } from "$lib/serv/groc-landing";
	import { query } from "$lib/util/url";
	import { Subject, switchMap, tap, type ValueFromArray, type Subscription, shareReplay, BehaviorSubject } from "rxjs";
	import { KEY_AISLE } from "../Aisle.svelte";
	import UserSpecificSwimlane, { NUM_SWIMLANE_ITEMS } from "../UserSpecificSwimlane.svelte";
	import { onDestroy, onMount } from "svelte";
	import { BUY_AGAIN } from "../UserSpecificAisle.svelte";

	let refresh$ = new BehaviorSubject<boolean>(false);
	
	export let data: Pick<ValueFromArray<StoreLanding["layout"]>, "title" | "endpoint">;
	export let pageUrl: URL;
	export let getGridViewUrl: ((url:string, compare: (targetUrl:URL|string) => boolean) => void) | undefined;

	$: cache = refresh$.pipe(
		switchMap(() => fetch$<Data>(new URL(`ca://grocery${data.endpoint}&limit=${NUM_SWIMLANE_ITEMS}`), SPKEYS, { db: getDB(), msMaxCacheAge: 0 })),
		tap(loader => subjUrlGen.next(loader.payload?.all ?? '')),
		// tap(({payload}) => console.log('cache refreshed', payload?.products?.length)),
	);

	let gridViewUrl: string;
	// let store: string;

	const subjUrlGen = new Subject<string>();
	
	type Data = {products: ProductData[], all: string, type:string};
	
	$: {
		// [,store] = data?.endpoint.match(/store_code=([A-Z0-9]+)&?/) ?? []; // "/products/deals-for-you/top?store_code=KC24"
		// i.e. refresh whenever `data` changes
		refresh$.next(true);
	}

	$: gridViewUrl = `/?${query(pageUrl).set(KEY_AISLE, DEALS_AISLE_ID)}`;

	let subCache: Subscription;
	$: {
		subCache?.unsubscribe();
		subCache = subjUrlGen.subscribe(url => {
			// const id = url.split('/').pop();
			gridViewUrl = `/?${query(pageUrl).set(KEY_AISLE, DEALS_AISLE_ID)}`;
			getGridViewUrl?.(gridViewUrl, targetUrl => {
				const q = query(targetUrl);
				return q.hasValue(KEY_AISLE, DEALS_AISLE_ID) && !q.has(BUY_AGAIN);
			});
		});
	}

	onDestroy(() => {
		subCache.unsubscribe();
	})
</script>

<UserSpecificSwimlane
	cache={$cache}
	title={data.title}
	{gridViewUrl}
	on:product
/>